import { ListPayloadCreator } from '../../types';
import dispatchListItemsNextAction from '../misc/dispatchListItemsNextAction';
import fetchParams from '../misc/fetchParams';

const payloadCreatorNewestWithFetch: ListPayloadCreator =
  (idName, api, slice, sliver, nextAction) =>
  async (_, { getState, dispatch }) =>
    api
      .getListCreatedBetween({}, { ...fetchParams(getState, slice, sliver), scanForward: false })
      .then((data) => dispatchListItemsNextAction({ data, idName, dispatch, nextAction }));

export default payloadCreatorNewestWithFetch;
